import React from 'react'
import Image from 'next/image'

//* Style
import ImageStyle from "./style"

const CustomImage = React.forwardRef(({ src, alt, className, onClick, ...props }, ref) => {
    return (
        <ImageStyle onClick={onClick} className={`imageCont ${className || ''} `} layout='fill' ref={ref}>
            <Image
                priority={props.priority}
                loading={props.priority ? undefined : 'lazy'}
                layout='fill'
                unoptimized={true}
                src={src}
                alt={alt || 'image'} className="image" />
        </ImageStyle>
    );
})

export default CustomImage
